import executiveReports from '../../api/executiveReports';

export const state = {
  metrics: {},
  contactAnalytics: {},
  sentimentAnalytics: {},
  operationalAnalytics: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getExecutiveMetrics: ({ metrics }) => metrics,
  getContactAnalytics: ({ contactAnalytics }) => contactAnalytics,
  getSentimentAnalytics: ({ sentimentAnalytics }) => sentimentAnalytics,
  getOperationalAnalytics: ({ operationalAnalytics }) => operationalAnalytics,
  getUIFlags: ({ uiFlags }) => uiFlags,
};

export const actions = {
  fetchExecutiveReport: async ({ commit }, { since } = {}) => {
    commit('SET_UI_FLAGS', { isFetching: true });
    try {
      const response = await executiveReports.getExecutiveMetrics({ since });
      commit('SET_EXECUTIVE_METRICS', response.data.payload);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAGS', { isFetching: false });
    }
  },

  fetchContactAnalytics: async ({ commit }, { since } = {}) => {
    commit('SET_UI_FLAGS', { isFetching: true });
    try {
      const response = await executiveReports.getContactAnalytics({ since });
      commit('SET_CONTACT_ANALYTICS', response.data.payload);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAGS', { isFetching: false });
    }
  },

  fetchSentimentAnalytics: async ({ commit }, { since } = {}) => {
    commit('SET_UI_FLAGS', { isFetching: true });
    try {
      const response = await executiveReports.getSentimentAnalytics({ since });
      commit('SET_SENTIMENT_ANALYTICS', response.data.payload);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAGS', { isFetching: false });
    }
  },

  fetchOperationalAnalytics: async ({ commit }, { since } = {}) => {
    commit('SET_UI_FLAGS', { isFetching: true });
    try {
      const response = await executiveReports.getOperationalAnalytics({ since });
      commit('SET_OPERATIONAL_ANALYTICS', response.data.payload);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAGS', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAGS(state, payload) {
    state.uiFlags = { ...state.uiFlags, ...payload };
  },
  SET_EXECUTIVE_METRICS(state, payload) {
    state.metrics = payload;
  },
  SET_CONTACT_ANALYTICS(state, payload) {
    state.contactAnalytics = payload;
  },
  SET_SENTIMENT_ANALYTICS(state, payload) {
    state.sentimentAnalytics = payload;
  },
  SET_OPERATIONAL_ANALYTICS(state, payload) {
    state.operationalAnalytics = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
